import type { Meeting } from "@/api/meetings";

const minutes = (ms: number) => Math.round(ms / 60_000);

/** What a processing meeting is doing: "Transcribing · 52 of 67 min", then "Writing the notes…". */
export function processingLabel(meeting: Pick<Meeting, "progress">): string {
  const progress = meeting.progress;
  if (progress?.stage === "transcribing") {
    return `Transcribing · ${minutes(progress.transcribed_ms)} of ${Math.max(1, minutes(progress.total_ms))} min`;
  }
  return progress?.stage === "writing" ? "Writing the notes…" : "Kory is writing the notes…";
}
